<template>
  <div class="official-edit">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="small">
      <div class="white-container">
        <el-form-item label="活动标题" prop="name" style="width: 500px">
          <el-input v-model="form.name" placeholder="请输入活动标题最多不超过二十个字" maxlength="20" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="比赛形式" prop="competitionFormat" style="width: 500px">
          <el-input v-model="form.competitionFormat" placeholder="请输入比赛形式最多不超过十二个字" maxlength="20" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="活动城市" prop="regionList" style="width:300px">
          <el-cascader v-model="form.regionList" :options="cityOptions" placeholder="请选择俱乐部省/市" clearable />
          <!-- <el-select ref="cityBox" v-model="form.region" placeholder="城市">
            <el-option v-for="item in cityList" :key="item" :label="item" :value="item" />
          </el-select> -->
        </el-form-item>
        <el-form-item label="活动日期" prop="registrationDate" style="width:500px">
          <el-date-picker
            v-model="form.registrationDate"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <!-- <el-form-item label="活动时间" prop="registrationTime" style="width:460px">
          <el-time-picker
            v-model="form.registrationTime"
            is-range
            range-separator="至"
            start-placeholder="活动开始时间"
            end-placeholder="活动结束时间"
            placeholder="选择时间范围"
          />
        </el-form-item> -->
        <el-form-item label="活动介绍" prop="content" style="width: 100%">
          <el-input v-model="form.content" type="textarea" placeholder="请输入活动介绍，最多不超过255个字" :disabled="disabled" maxlength="255" />
        </el-form-item>
        <el-form-item label="报名流程" prop="activityFlow" style="width: 100%">
          <el-input v-model="form.activityFlow" type="textarea" placeholder="请输入报名流程，最多不超过255个字" :disabled="disabled" maxlength="255" />
        </el-form-item>
        <div class="flex" style="flex-wrap:wrap;">
          <el-form-item label="活动地址" prop="otherAddress">
            <el-input v-model="form.otherAddress" placeholder="请输入活动地址" :disabled="disabled" />
          </el-form-item>
          <div class="flex">
            <el-form-item style="margin-left:20px; margin-right:20px;" class="btn-form-item">
              <el-button type="primary" @click="openMap">打开地图</el-button>
            </el-form-item>
            <el-form-item :key="2" label="坐标" prop="location" class="lng-label">
              <el-input v-model="form.location" placeholder="请填写经纬度" style="width: 200px !important;" />
            </el-form-item>
          </div>
        </div>
        <el-form-item label="报名开放时间" prop="registrationBeginTimeObj" style="width:320px">
          <el-date-picker
            v-model="form.registrationBeginTimeObj"
            type="datetime"
            placeholder="报名开放时间"
          />
        </el-form-item>
        <el-form-item label="报名截止时间" prop="registrationEndTimeObj" style="width:320px">
          <el-date-picker
            v-model="form.registrationEndTimeObj"
            type="datetime"
            placeholder="报名截止时间"
          />
        </el-form-item>
        <el-form-item label="球队数量" prop="maxTeam" style="width: 500px">
          <el-input v-model="form.maxTeam" type="number" placeholder="请输入球队数量" :disabled="disabled" />
        </el-form-item>
        <div class="flex">
          <el-form-item label="竞赛章程" prop="competitionRules.content" style="width: 500px">
            <el-input v-model="form.competitionRules.content" placeholder="请输入竞赛章程最多不超过十八个字" maxlength="18" :disabled="disabled" />
          </el-form-item>
          <el-form-item label="跳转链接" prop="competitionRules.linkTo" style="width: 500px">
            <el-input v-model="form.competitionRules.linkTo" placeholder="请输入跳转链接" :disabled="disabled" />
          </el-form-item>
        </div>
        <div class="flex">
          <el-form-item label="赛事中心" prop="eventCenter.content" style="width: 500px">
            <el-input v-model="form.eventCenter.content" placeholder="请输入赛事中心最多不超过十八个字" maxlength="18" :disabled="disabled" />
          </el-form-item>
          <el-form-item label="跳转链接" prop="eventCenter.linkTo" style="width: 500px">
            <el-input v-model="form.eventCenter.linkTo" placeholder="请输入跳转链接" :disabled="disabled" />
          </el-form-item>
        </div>

      </div>
      <div class="white-container marginTop">
        <div class="img-text">关联活动</div>
        <div v-for="(item, index) in form.relatedActivities" :key="index" class="related-activity-row">
          <div class="related-activity-main flex">
            <div class="related-activity-form">
              <el-form-item
                :label="`关联活动 ${index + 1}`"
                :prop="`relatedActivities.${index}.type`"
                :rules="{ required: true, message: '请选择活动类型', trigger: 'change' }"
              >
                <el-select v-model="item.type" placeholder="请选择活动类型" clearable style="width: 220px" @change="handleRelatedActivityTypeChange(index)">
                  <el-option
                    v-for="opt in activityTypeOptions"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                :label="'关联活动'"
                :prop="`relatedActivities.${index}.activityId`"
                :rules="{ required: true, message: '请选择关联活动', trigger: 'change' }"
              >
                <el-autocomplete
                  v-model="item.name"
                  :fetch-suggestions="(queryString, cb) => searchRelatedActivity(queryString, index, cb)"
                  value-key="name"
                  placeholder="输入活动名称或活动ID搜索"
                  style="width: 280px"
                  clearable
                  @select="(val) => handleRelatedActivitySelect(val, index)"
                  @clear="handleRelatedActivityClear(index)"
                >
                  <template slot-scope="{ item: act }">
                    <div>{{ act.name }} ID: {{ act.activityId }}</div>
                  </template>
                </el-autocomplete>
              </el-form-item>
            </div>
            <div class="related-activity-image flex">
              <UploadImage
                :url="item.imageUrl"
                save-path="running/"
                size-tips="1005px*503px"
                :limit-size="5"
                :show-replace="false"
                class-name="related-activity-upload"
                @upload="data => handleRelatedActivityImageUpload(data, index)"
              />
              <i class="el-icon-delete" @click="removeRelatedActivity(index)" />
            </div>
          </div>
        </div>
        <div class="add-related-activity">
          <el-button type="primary" icon="el-icon-plus" @click="addRelatedActivity">新增</el-button>
        </div>
      </div>
      <div class="white-container marginTop">
        <div class="img-text"><span>*</span>上传图片</div>
        <div class="flex">
          <el-form-item label="" prop="activityImageVO.activityDetailsPageHeader" class="image-config">
            <div class="flex uploadImg-cont">
              <UploadImage :disabled="disabled" title="活动主图" :url="form.activityImageVO.activityDetailsPageHeader" save-path="running/" size-tips="1125px*1125px" @triggerReg="handleCheckChartReg" @upload="data => (form.activityImageVO.activityDetailsPageHeader = data)" />
            </div>
          </el-form-item>
          <el-form-item label="" prop="activityImageVO.shareImage" class="image-config">
            <div class="flex uploadImg-cont">
              <UploadImage :disabled="disabled" title="活动分享海报" :url="form.activityImageVO.shareImage" save-path="running/" size-tips="849px*849px" @triggerReg="handleCheckChartReg2" @upload="data => (form.activityImageVO.shareImage = data)" />
            </div>
          </el-form-item>
          <el-form-item label="" prop="activityImageVO.shareCardImage" class="image-config">
            <div class="flex uploadImg-cont">
              <UploadImage :disabled="disabled" title="活动分享卡片" :url="form.activityImageVO.shareCardImage" save-path="running/" size-tips="500px*400px" @triggerReg="handleCheckChartReg3" @upload="data => (form.activityImageVO.shareCardImage = data)" />
            </div>
          </el-form-item>
          <el-form-item label="" prop="activityImageVO.activityListPagePicture" class="image-config">
            <div class="flex uploadImg-cont">
              <UploadImage :disabled="disabled" title="活动列表页" :url="form.activityImageVO.activityListPagePicture" save-path="running/" size-tips="381px*561px" @triggerReg="handleCheckChartReg4" @upload="data => (form.activityImageVO.activityListPagePicture = data)" />
            </div>
          </el-form-item>
        </div>

      </div>
      <el-form-item style="width:100%;margin-top:30px;">
        <div class="flex btns">
          <el-button type="info" @click="cancel">取消</el-button>
          <el-button type="primary" @click="submit">保存</el-button>
        </div>
      </el-form-item>
      <!-- <el-form-item style="width:100%;margin-top:30px;margin-left:-50px" v-if="!id">
        <div class="flex btns">
          <el-button type="primary" @click="submit">确定</el-button>
        </div>
      </el-form-item> -->

    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>
<script>
import UploadImage from '@/components/UploadImage';
import Dialog from '@/components/Dialog';
import cityOptions from '@/model/cityCascader';
export default {
  components: { UploadImage, Dialog },
  data() {
    return {
      form: {
        name: '',
        competitionFormat: '',
        region: '',
        registrationDate: [],
        // registrationTime: '',
        content: '',
        activityFlow: '',
        otherAddress: '',
        location: '',
        registrationBeginTimeObj: '',
        registrationEndTimeObj: '',
        maxTeam: '',
        competitionRules: {
          title: '竞赛章程',
          linkTo: '',
          content: '',
        },
        eventCenter: {
          title: '赛事中心',
          linkTo: '',
          content: '',
        },
        activityImageVO: {
          activityDetailsPageHeader: '',
          shareImage: '',
          shareCardImage: '',
          activityListPagePicture: '',
        },
        longitude: '',
        latitude: '',
        beginTime: '',
        endTime: '',
        registrationBeginTime: '',
        registrationEndTime: '',
        relatedActivities: [],
      },
      activityTypeOptions: [
        { label: 'UA STAR', value: 0 },
        { label: 'UA NEXT COMBINE', value: 1 },
      ],
      relatedActivityOptions: {},
      bannerMap: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() + (15 * 24 * 60 * 60 * 1000);
        },
      },
      formDialogShow: false,
      information: {},
      rules: {
        name: [
          { required: true, message: '请输入活动标题', trigger: 'blur' },
        ],
        competitionFormat: [
          { required: true, message: '请输入比赛形式', trigger: 'blur' },
        ],
        regionList: [
          { required: true, message: '请选择活动城市', trigger: 'change' },
        ],
        registrationDate: [
          { required: true, message: '请选择活动日期', trigger: 'change' },
        ],
        // registrationTime: [
        //   { required: true, message: '请选择活动时间', trigger: 'change' },
        // ],
        content: [
          { required: true, message: '请输入活动介绍', trigger: 'blur' },
        ],
        activityFlow: [
          { required: true, message: '请输入报名流程', trigger: 'blur' },
        ],
        otherAddress: [
          { required: true, message: '请输入活动地址', trigger: 'blur' },
        ],
        location: [
          { required: true, message: '请输入坐标', trigger: 'blur' },
        ],
        registrationBeginTimeObj: [
          { required: true, message: '请选择报名开放时间', trigger: 'change' },
        ],
        registrationEndTimeObj: [
          { required: true, message: '请选择报名截止时间', trigger: 'change' },
        ],
        maxTeam: [
          { required: true, message: '请输入球队数量', trigger: 'blur' },
        ],
        'competitionRules.content': [
          { required: true, message: '请输入竞赛章程', trigger: 'blur' },
        ],
        'competitionRules.linkTo': [
          { required: true, message: '请输入跳转链接', trigger: 'blur' },
        ],
        'eventCenter.content': [
          { required: true, message: '请输入赛事中心', trigger: 'blur' },
        ],
        'eventCenter.linkTo': [
          { required: true, message: '请输入跳转链接', trigger: 'blur' },
        ],
        'activityImageVO.activityDetailsPageHeader': [
          { required: true, message: '请上传活动主图', trigger: 'blur' },
        ],
        'activityImageVO.shareImage': [
          { required: true, message: '请上传活动分享海报', trigger: 'blur' },
        ],
        'activityImageVO.shareCardImage': [
          { required: true, message: '请上传活动分享卡片', trigger: 'blur' },
        ],
        'activityImageVO.activityListPagePicture': [
          { required: true, message: '请上传活动列表页', trigger: 'blur' },
        ],
      },
      choozeOther: false,
      id: null,
      cityList: [],
      cityOptions,
    };
  },
  computed: {
    disabled() {
      return false;
    },

  },
  mounted() {
    this.loadBanner();
    this.$Api.rugby.officialActivityCity().then(res => {
      this.cityList = res;
      console.log(res.data);
    });
    const { query } = this.$route;
    const id = query.id || query.copyId;

    if (query.id || query.copyId) {
      this.id = id;
      this.getActivityDetail(id);
    }
    this.cancelText = query.id ? '编辑' : '新增';
    // this.getLeaderList('');
  },
  methods: {
    loadBanner() {
      return this.$Api.rugby.officialRelatedActivityBanner().then(res => {
        this.bannerMap = res || {};
      });
    },
    fillDefaultBanner() {
      const fill = () => {
        const map = this.bannerMap;
        this.form.relatedActivities.forEach((item, index) => {
          if (!item.imageUrl && (item.type === 0 || item.type === 1)) {
            const key = item.type === 0 ? 'UA STAR' : 'UA NEXT COMBINE';
            const url = map[key];
            if (url) {
              this.$set(this.form.relatedActivities, index, { ...item, imageUrl: url });
            }
          }
        });
      };
      if (Object.keys(this.bannerMap).length) {
        fill();
      } else {
        this.loadBanner().then(fill);
      }
    },
    handleRelatedActivityTypeChange(index) {
      const item = this.form.relatedActivities[index];
      if (item.type === undefined || item.type === null || item.type === '') {
        return;
      }
      if (!item.imageUrl) {
        const key = item.type === 0 ? 'UA STAR' : 'UA NEXT COMBINE';
        const url = this.bannerMap[key];
        if (url) {
          this.$set(this.form.relatedActivities, index, { ...item, imageUrl: url });
        }
      }
    },
    searchRelatedActivity(keyword, index, cb) {
      const item = this.form.relatedActivities[index];
      const type = item.type;
      if (type === undefined || type === null || type === '') {
        cb([]);
        return;
      }
      this.$Api.rugby.officialRelatedActivitySearch({ type, keyword }).then(res => {
        const list = res || [];
        this.$set(this.relatedActivityOptions, index, list);
        cb(list);
      }).catch(() => {
        cb([]);
      });
    },
    handleRelatedActivitySelect(val, index) {
      const current = this.form.relatedActivities[index];
      const hasType = val.type !== undefined && val.type !== null && val.type !== '';
      this.$set(this.form.relatedActivities, index, {
        ...current,
        activityId: val.activityId,
        name: val.name,
        imageUrl: val.imageUrl || (current.type === 0 ? this.bannerMap['UA STAR'] : this.bannerMap['UA NEXT COMBINE']),

        jumpUrl: val.jumpUrl,
        combineMode: val.combineMode,
        type: hasType ? val.type : current.type,
      });
      this.$refs.form.validateField(`relatedActivities.${index}.activityId`);
    },
    handleRelatedActivityClear(index) {
      this.$set(this.form.relatedActivities, index, {
        ...this.form.relatedActivities[index],
        activityId: '',
        name: '',
        imageUrl: '',
        jumpUrl: '',
        combineMode: '',
      });
      this.handleRelatedActivityTypeChange(index);
    },
    handleRelatedActivityImageUpload(url, index) {
      this.$set(this.form.relatedActivities, index, {
        ...this.form.relatedActivities[index],
        imageUrl: url,
      });
    },
    addRelatedActivity() {
      this.form.relatedActivities.push({
        type: '',
        activityId: '',
        name: '',
        imageUrl: '',
        jumpUrl: '',
        combineMode: '',
      });
    },
    removeRelatedActivity(index) {
      this.form.relatedActivities.splice(index, 1);
      this.$delete(this.relatedActivityOptions, index);
    },
    openMap() {
      window.open('https://lbs.qq.com/getPoint/');
    },
    getActivityDetail(id) {
      this.$Api.rugby.officialActivityDetail(id).then(res => {
        res.location = `${res.latitude},${res.longitude}`;
        res.registrationBeginTimeObj = new Date(res.registrationBeginTime);
        res.registrationEndTimeObj = new Date(res.registrationEndTime);
        res.registrationDate = [new Date(res.beginTime), new Date(res.endTime)];
        // res.registrationDate = new Date(res.beginTime.split(' ')[0]);
        // res.registrationTime = [new Date(res.beginTime), new Date(res.endTime)];
        res.regionList = res.region.split('/');
        res.relatedActivities = res.relatedActivities || [];
        this.form = res;
        this.fillDefaultBanner();
      });
    },
    submit() {
      this.formDialogShow = true;
      const text = this.id ? '是否保存以上修改内容？' : '是否提交以上内容？';
      this.information = {
        operation: "submit",
        icon: "warn",
        subTitle: `${text}`,
      };
    },
    cancel() {
      this.formDialogShow = true;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: `是否放弃${this.cancelText}，返回上级页面？`,
      };
    },
    handleCheckChartReg(val) {
      this.$refs.form.validateField("activityImageVO.activityDetailsPageHeader");
    },
    handleCheckChartReg2(val) {
      this.$refs.form.validateField("activityImageVO.shareImage");
    },
    handleCheckChartReg3(val) {
      this.$refs.form.validateField("activityImageVO.shareCardImage");
    },
    handleCheckChartReg4(val) {
      this.$refs.form.validateField("activityImageVO.activityListPagePicture");
    },
    dialogSuccess() {
      console.log(this.form);
      if (this.information.operation && this.information.operation === 'delete') {
        this.goBack();
      } else if (this.information.operation && this.information.operation === 'submit') {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.addActivity();
          } else {
            return false;
          }
        });
      }
    },
    goBack() {
      this.$router.back(-1);
    },
    addActivity() {
      const param = { ...this.form };
      param.registrationDateStartStr = this.getTime(param.registrationDate[0]);
      param.registrationDateEndStr = this.getTime(param.registrationDate[1]);
      param.registrationTimeStrat = this.getTime(param.registrationDate[0], 'hh:mm:ss');
      param.registrationTimeEnd = this.getTime(param.registrationDate[1], 'hh:mm:ss');
      param.beginTime = param.registrationDateStartStr + ' ' + param.registrationTimeStrat;
      param.endTime = param.registrationDateEndStr + ' ' + param.registrationTimeEnd;
      param.registrationBeginTime = this.getTime(param.registrationBeginTimeObj, 'yyyy-mm-dd hh:mm:ss');
      param.registrationEndTime = this.getTime(param.registrationEndTimeObj, 'yyyy-mm-dd hh:mm:ss');
      param.longitude = param.location.split(',')[1];
      param.latitude = param.location.split(',')[0];
      param.region = param.regionList.join('/');
      delete param.registrationDate;
      // delete param.registrationTime;
      delete param.registrationBeginTimeObj;
      delete param.registrationEndTimeObj;
      delete param.location;
      delete param.registrationTimeStrat;
      delete param.registrationTimeEnd;
      delete param.registrationDateStartStr;
      delete param.registrationDateEndStr;
      delete param.regionList;
      console.log(param);
      if (this.cancelText === '编辑') { // 修改
        this.$Api.rugby.officialActivityEdit({ ...param }).then(res => {
          this.$message.success(`保存成功`);
          setTimeout(() => {
            this.goBack();
          }, 2000);
        }).catch(err => {
          if (err && !err.success) {
            this.$message.error(err.errorMessage || `${this.cancelText}失败`);
          }
        });
      } else { // 新增
        delete param.eventNumber;
        delete param.memberNumber;

        this.$Api.rugby.officialActivityAdd({ ...param }).then(res => {
          this.$message.success(`新增成功`);
          setTimeout(() => {
            this.goBack();
          }, 2000);
        }).catch(err => {
          if (err && !err.success) {
            this.$message.error(err.errorMessage || `${this.cancelText}失败`);
          }
        });
      }
    },
    getTime (time, type = 'yyyy-mm-dd') {
      const getDate = new Date(time);
      const getYear = getDate.getFullYear();
      let getMonth = getDate.getMonth() + 1;
      if (getMonth < 10) {
        getMonth = '0' + getMonth;
      }
      let getDay = getDate.getDate();
      if (getDay < 10) {
        getDay = '0' + getDay;
      }
      const hour = getDate.getHours() < 10 ? '0' + getDate.getHours() : getDate.getHours();
      const minute = getDate.getMinutes() < 10 ? '0' + getDate.getMinutes() : getDate.getMinutes();
      const second = getDate.getSeconds() < 10 ? '0' + getDate.getSeconds() : getDate.getSeconds();
      switch (type) {
        case 'yyyy-mm-dd':
          return getYear + '-' + getMonth + '-' + getDay;
        case 'yyyy-mm-dd hh:mm:ss':
          return getYear + '-' + getMonth + '-' + getDay + ' ' + hour + ':' + minute + ':' + second;
        case 'hh:mm:ss':
          return hour + ':' + minute + ':' + second;
      }
    },
  },
};
</script>
<style lang="less" scoped>
  .btns {
    align-items: center;
    justify-content: center;
  }
  .marginTop {
    margin-top: 30px;
    .img-text {
      margin-bottom: 10px;
      span {
        color: #f56c6c;
        margin-right: 4px;
      }
    }
  }
  .related-activity-row {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #EBEEF5;
    &:last-child {
      border-bottom: none;
    }
  }
  .related-activity-main {
    align-items: center;
    justify-content: space-between;
    width: 1000px;
  }
  .related-activity-form {
    flex: 1;
  }
  .related-activity-image {
    align-items: flex-start;
    margin-left: 40px;
    /deep/ .related-activity-upload {
      margin-right: 0;
      .uploader-image .el-upload {
        width: 335px;
        height: 168px;
        border-radius: 4px;
      }
      .uploader-image .el-icon-plus {
        width: 335px;
        height: 168px;
        line-height: 168px;
      }
      .uploader-info {
        display: inline-block;
        margin: 0 4px;
        text-align: center;
      }
    }
    .el-icon-delete {
      margin-left: 12px;
      font-size: 16px;
      color: #f56c6c;
      cursor: pointer;
      margin-top:80rpx;
    }
  }
  .add-related-activity {
    text-align: center;
    margin-top: 20px;
  }
</style>
<style lang="less">
.official-edit {
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
    .form-radio {
      line-height: 32px;
      height: 32px;
      align-items: center;
    }
    .el-checkbox__inner::after {
      border-right-width: 2.5px;
      border-bottom-width: 2.5px;
    }
    .el-checkbox__label {
      color: #494949;
    }
    .coupon-uploader {
      margin: unset;
      display: flex;
      height: 34px;
      line-height: 34px;
      .el-button {
        width: 115px;
        height: 34px;
      }
      .coupon_tip {
        width: 250px;
        white-space: nowrap;
        margin-left: 10px;
        margin-right: 20px;
      }
      .download-file {
        white-space: nowrap;
      }
    }
  }
  .coach-select-box + .el-form-item__error {
    top: unset !important;
    bottom: 43px !important;
  }
  .uploadImg-cont {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .uploader {
      margin-bottom: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  .form-icon {
    margin-left: 10px;
    .el-icon-close {
      color: #9b9b9b;
      cursor: pointer;
      &:hover {
        color: #000000;
      }
    }
  }

  .product-config,
  .image-config {
    margin-right: 30px;
    .el-form-item__label {
      float: none;
    }
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .lng-label .el-form-item__label {
    width: 60px !important;
  }
  .lng-label .el-form-item__content {
    margin-left: 60px !important;
  }
  .btn-form-item.el-form-item--small {
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
}
</style>
